import React, { useEffect } from "react";
import { useLocalStorage } from "react-use";

interface Props {
  fullName?: string | null;
}

interface GreetingData {
  message: string;
  timestamp: number;
}

const getTimeBasedMessages = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    // Morning messages
    return ["Good morning", "Morning", "Hello", "Hi there", "Hey"];
  } else if (hour >= 12 && hour < 17) {
    // Afternoon messages
    return ["Good afternoon", "Afternoon", "Hello", "Hi there", "Hey"];
  } else if (hour >= 17 && hour < 21) {
    // Evening messages
    return ["Good evening", "Evening", "Hello", "Hi there", "Hey"];
  } else {
    // Night messages
    return ["Working late", "Night owl", "Hello", "Hi there", "Hey"];
  }
};

const generateNewMessage = (): GreetingData => {
  const messages = getTimeBasedMessages();
  const randomMessage = messages[Math.floor(Math.random() * messages.length)];

  return {
    message: randomMessage,
    timestamp: Date.now(),
  };
};

export const GreetingHeader: React.FC<Props> = ({ fullName }) => {
  const [greetingData, setGreetingData] = useLocalStorage<GreetingData>("greeting-message");

  useEffect(() => {
    const now = Date.now();
    const fifteenMinutes = 15 * 60 * 1000;

    // Check if we need a new message (no data or expired)
    if (!greetingData || now - greetingData.timestamp >= fifteenMinutes) {
      setGreetingData(generateNewMessage());
    }
  }, [greetingData, setGreetingData]);

  const message = greetingData?.message || "";

  return (
    <div className="mb-8 flex items-center gap-3 text-2xl font-normal text-gray-700">
      <span>
        {message}
        {fullName ? `, ${fullName}` : ""}!
      </span>
    </div>
  );
};
